// extracted by mini-css-extract-plugin
module.exports = {"button":"roundedButton-module--button--275ou"};